import React from 'react';
import { getMetaDescription } from '@/utils/getMetaDescription';
import { checkForWrongDomain } from '@/utils/checkForWrongDomain';
import Layout from '@/components/Layout';
import Collections from '@/containers/Collections';
import { getSSRStoreData } from '../../utils/ssrPageData';
import { useSetSSRStore, useSSRSelector } from '../../redux';
import { PAGE_TYPE_ID } from 'src/utils/constants';
import { set404Response } from 'src/utils/404Redirect';
import { CanonicalUrlData } from 'src/utils/Types/canonicalUrl';
import { getRequiredCtxProps } from 'src/utils/getRequiredCtxProps';
import { fetchAdditionalPageSeoDetails } from 'src/utils/fetchAdditionalPageSeoDetails';
import { handleCategoryCollectionRedirect } from 'src/utils/productUtils';
import Error404 from 'src/containers/404Page';

const CollectionsSpecificToId = (props) => {
  useSetSSRStore(props.ssrStore);
  const storeInfo = useSSRSelector((state) => state.storeReducer.store);
  if (props?.notFound) {
    return <Error404 />
  }
  return (
    <Layout
      store={storeInfo}
      title={
        props?.advCustomSeoDetails?.title?.value
          ? props?.advCustomSeoDetails?.title?.value
          : `${storeInfo?.store_info?.name}${
              storeInfo?.address?.visibility === 1 && storeInfo?.address?.city
                ? `,${storeInfo?.address?.city}`
                : ''
            } - Order Online`
      }
      OGTitle={props?.advCustomSeoDetails?.og_title?.value || null}
      OGDescription={props?.advCustomSeoDetails?.og_description || null}
      Icon={storeInfo?.store_info?.logo_image}
      metaDescription={
        props?.advCustomSeoDetails?.description
          ? props?.advCustomSeoDetails?.description
          : storeInfo && getMetaDescription(storeInfo)
      }
      OGImage={storeInfo?.store_info?.logo_image}
      isCustomDomain={props.isCustomDomain}
      canonicalTagUrl={props?.canonicalUrlData?.item_group_details?.link}
      {...props}
    >
      <Collections {...props} />
    </Layout>
  );
};

export async function getServerSideProps(ctx) {
  if (checkForWrongDomain(ctx)) return {};

  let propData = {
    collections: [],
    canonicalUrlData: {},
  };
  const { collectionId } = ctx.params;
  const isCollectionIdNumeric = /^\d+$/.test(collectionId);

  const propType = await getSSRStoreData(ctx, {
    checkForSubscriptionExpiry: true,
    additionalDataToFetch: ['collections', 'categories', 'canonicalData'],
    canonicalParams: {
      type: PAGE_TYPE_ID.COLLECTION,
      typeId: isCollectionIdNumeric ? collectionId : null,
      slug_url: !isCollectionIdNumeric ? collectionId : null
    }
  });

  const canonicalUrlData : CanonicalUrlData = propType?.ssrStore?.catalogReducer?.canonicalData;

  let advCustomSeoDetails = {};
  
    if (canonicalUrlData?.status) {
      const storeInfo = propType.ssrStore.storeReducer.store;
      advCustomSeoDetails = await fetchAdditionalPageSeoDetails({
        type: 'collection',
        typeId: canonicalUrlData?.item_group_details?.id,
        storeInfo,
      });
    } else {
      return set404Response(ctx, propType);
    }
  
   if (canonicalUrlData?.item_group_details?.is_redirected) {
      const redirectionLink = canonicalUrlData?.item_group_details?.link
      return handleCategoryCollectionRedirect({ ctx, redirectionLink, type: PAGE_TYPE_ID.COLLECTION, propType });
    }

  const extraProps = getRequiredCtxProps(ctx, propType);

  propData = { ...propData, ...propType };

  return { props: { ...propData, ...extraProps, advCustomSeoDetails, canonicalUrlData } };
}

export default CollectionsSpecificToId;
